module.exports = __webpack_public_path__ + "7298cf6483729792b260eca1a14f988f.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/logdesign/img/empty_img.png
// module id = 2591
// module chunks = 1